import React from 'react';
import useGetBackgroundColor from '../hooks/useGetBackgroundColor';

const AvatarContainer = ({children, user, containerStyle = '', ...props}) => {
  const userId = user?.id;
  const backgroundColor = useGetBackgroundColor(userId || 0);
  return (
    <div
      className={`rounded-full overflow-hidden mb-1 mx-auto ${containerStyle}`}>
      <div className={`aspect-w-1 aspect-h-1 relative ${backgroundColor}`}>
        <button {...props}>{children}</button>
      </div>
    </div>
  );
};

export const Avatar = ({initial, user, character, containerStyle, textSize, ...props}) => {
  return (
    <AvatarContainer user={user} containerStyle={containerStyle} {...props}>
      {initial ? (
        <img src={initial} className="w-full h-full absolute top-0 left-0" />
      ) : (
        <p className={`w-full h-full absolute top-0 left-0 flex items-center justify-center text-white font-bold ${textSize}`}>
          {character ? (
            <span className="uppercase">{character}</span>
          ) : (
            <i className={"fas fa-fw fa-user"} />
          )}
        </p>
      )}
    </AvatarContainer>
  );
};
